import { connect } from 'react-redux';
import getReasonForEmptyProductGrid from 'redux/modules/search/selectors/get-reason-for-empty';

import generateOffersBreadCrumbs from 'components/Offers/utils/generate-offers-breadcrumbs';
import ProductGridEmpty from './ProductGridEmpty';

export default connect(state => ({
  breadcrumbs: generateOffersBreadCrumbs(state),
  pageType: 'offer',
  reason: getReasonForEmptyProductGrid(state),
}))(ProductGridEmpty);
